module.exports = __webpack_public_path__ + "img/UK & Ireland.df2413b6.svg";